import http from "../../util/http"
export default class RecordApi {
  constructor(){
    this.post = http.post;
    this.get = http.get;
    this.PREFIX = "/share-foreign"
  }
  confirm(data){
    let url = this.PREFIX + "/entRecord/addOrEdit"
    return this.post(url,data)
  }
  detail(data){
    let url = this.PREFIX + "/entRecord/getByCompanyId"
    return this.post(url,data)
  }
  list(data){
    let url = this.PREFIX + "/entRecord/getRecordPage"
    return this.post(url,data)
  }
  approval(data){
    let url = this.PREFIX + "/entRecord/audit"
    return this.post(url,data)
  }
  del(data){
    let url = this.PREFIX + "/entRecord/deleteUser"
    return this.post(url,data)
  }
  report(data){
    let url = this.PREFIX + "/entRecord/submit"
    return this.post(url,data)
  }
  submitApproval(data){
    let url = this.PREFIX + "/entRecord/submitApproval"
    return this.post(url,data)
  }
  submitTask(data){
    let url = this.PREFIX + "/entRecord/submitTask"
    return this.post(url,data)
  }
  complete(data){
    let url = this.PREFIX + "/entRecord/complete"
    return this.post(url,data)
  }
  //退回
  reject(data){
    let url = this.PREFIX + "/entRecord/reject"
    return this.post(url,data)
  }
    // 判断集团权限
  getAccessPermission(data) {
    let url = this.PREFIX + "/invi/getAccessPermission";
    return this.post(url,data)
  }
}
